import React from 'react'
import { MapPin } from 'lucide-react'

type Props={
    product_name:string,
    price:number,
    market_name:string,
    arrondissement:string,
    uml:string
}
function Market_price({product_name,price,market_name,arrondissement,uml}:Props) {
  return (
    <div className='group flex h-9 shrink-0 items-center gap-3 rounded-xl border border-primary/10 bg-white px-3 font-sans shadow-[0_4px_14px_rgba(40,180,70,0.12)] transition-all duration-300 hover:border-primary/30 hover:shadow-[0_6px_18px_rgba(40,180,70,0.2)]'>
        <div className='flex min-w-0 items-center gap-1.5'>
          <MapPin size={10} className='text-third' />
          {/* <span className='h-1.5 w-1.5 shrink-0 rounded-full bg-[#93C01F] shadow-[0_0_0_3px_rgba(147,192,31,0.14)]' /> */}
          <span className='max-w-[110px]  text-[11px] font-bold text-primary'>{market_name}</span>
        </div>
        <div className='h-4 w-px bg-gray-200' />
        <div className='flex min-w-0 items-center gap-1.5'>
          <span className='max-w-[120px]  text-[12px] font-semibold text-gray-800'>{product_name}</span>
          <span className='hidden items-center gap-0.5 text-[9px] text-gray-400 sm:flex'>
            {/* <MapPin size={10} className='text-third' /> */}
            <span className='h-1.5 w-1.5 shrink-0 rounded-full bg-[#93C01F] shadow-[0_0_0_3px_rgba(147,192,31,0.14)]' />
            {arrondissement}
          </span>
        </div>
        <div className='flex items-baseline gap-1 whitespace-nowrap'>
          <span className='text-[13px] font-black tracking-tight text-primary'>{price.toLocaleString('fr-FR')}</span>
          <span className='text-[9px] font-bold text-gray-400'>FCFA/{uml}</span>
        </div>
    </div>
  )
}

export default Market_price
